import React from 'react';
export const SuccessIcon = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "8", cy: "8", r: "6.5", stroke: "#0DC076" }),
        React.createElement("path", { d: "M5.2998 8L7.42113 10.1213C7.42113 10.1213 9.74002 7.80242 11.3102 6.23223", stroke: "#0DC076", "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export const FailIcon = () => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z", stroke: "#FE5B4C" }),
        React.createElement("path", { d: "M5.70069 5.7002L10.3002 10.2997M10.2997 5.7002L5.7002 10.2997", stroke: "#FE5B4C", "stroke-linecap": "round" })));
};
